import {useTheme} from '@mui/material';

interface IProps {
	children?: string | JSX.Element | JSX.Element[];
}

export default function ServicePatternIcon({children}: IProps) {
	const theme = useTheme();
	
	// @ts-ignore
	const first = theme.palette.primary[400];
	// @ts-ignore
	const second = theme.palette.primary[600];
	
	return (
		<div className="relative w-fit">
			<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M32.125 2.52591C34.5229 1.1415 37.4771 1.1415 39.875 2.52591L63.0519 15.9071C65.4498 17.2915 66.9269 19.85 66.9269 22.6188V49.3812C66.9269 52.15 65.4498 54.7085 63.0519 56.0929L39.875 69.4741C37.4771 70.8585 34.5229 70.8585 32.125 69.4741L8.94808 56.0929C6.55023 54.7085 5.07309 52.15 5.07309 49.3812V22.6188C5.07309 19.85 6.55023 17.2915 8.94809 15.9071L32.125 2.52591Z"
					fill="none" stroke="url(#paint0_linear_1074_2139)" strokeWidth="0.5"/>
				<path opacity="0.7"
				      d="M32.68 6.20548C34.7344 5.01936 37.2656 5.01936 39.32 6.20548L60.1428 18.2275C62.1972 19.4137 63.4628 21.6057 63.4628 23.9779V48.0221C63.4628 50.3943 62.1972 52.5863 60.1428 53.7725L39.32 65.7945C37.2656 66.9806 34.7344 66.9806 32.68 65.7945L11.8572 53.7725C9.80276 52.5863 8.53719 50.3943 8.53719 48.0221V23.9779C8.53719 21.6057 9.80276 19.4137 11.8572 18.2275L32.68 6.20548Z"
				      stroke="url(#paint0_linear_1074_2139)" strokeWidth="0.5"/>
				<path opacity="0.4"
				      d="M33.275 9.86196C34.9612 8.88841 37.0388 8.88841 38.725 9.86195L57.2737 20.5711C58.9599 21.5446 59.9987 23.3438 59.9987 25.2909V46.7091C59.9987 48.6562 58.9599 50.4554 57.2737 51.4289L38.725 62.138C37.0388 63.1116 34.9612 63.1116 33.275 62.138L14.7263 51.4289C13.0401 50.4554 12.0013 48.6562 12.0013 46.7091V25.2909C12.0013 23.3438 13.0401 21.5446 14.7263 20.5711L33.275 9.86196Z"
				      stroke="url(#paint0_linear_1074_2139)" strokeWidth="0.5"/>
				<path opacity="0.2"
				      d="M33.825 13.5444C35.1709 12.7674 36.8291 12.7674 38.175 13.5444L54.3596 22.8886C55.7055 23.6657 56.5346 25.1017 56.5346 26.6558V45.3442C56.5346 46.8983 55.7055 48.3343 54.3596 49.1114L38.175 58.4556C36.8291 59.2326 35.1709 59.2326 33.825 58.4556L17.6404 49.1114C16.2945 48.3343 15.4654 46.8983 15.4654 45.3442V26.6558C15.4654 25.1017 16.2945 23.6657 17.6404 22.8886L33.825 13.5444Z"
				      stroke="url(#paint0_linear_1074_2139)" strokeWidth="0.5"/>
				<path opacity="0.1"
				      d="M33.825 17.5444C35.1709 16.7674 36.8291 16.7674 38.175 17.5444L50.8955 24.8886C52.2414 25.6657 53.0705 27.1017 53.0705 28.6558V43.3442C53.0705 44.8983 52.2414 46.3343 50.8955 47.1114L38.175 54.4556C36.8291 55.2326 35.1709 55.2326 33.825 54.4556L21.1045 47.1114C19.7586 46.3343 18.9295 44.8983 18.9295 43.3442V28.6558C18.9295 27.1017 19.7586 25.6657 21.1045 24.8886L33.825 17.5444Z"
				      stroke="url(#paint0_linear_1074_2139)" strokeWidth="0.5"/>
				<defs>
					<linearGradient id="paint0_linear_1074_2139" x1="70.4634" y1="6.95193e-06" x2="-3.45482" y2="3.74127"
					                gradientUnits="userSpaceOnUse">
						<stop stopColor={first}/>
						<stop offset="0.515625" stopColor={second}/>
						<stop offset="1" stopColor={second}/>
					</linearGradient>
				</defs>
			</svg>
			<div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 service-icon">
				{children}
			</div>
		</div>
	);
}
